import React, { useContext, useState } from 'react';
import { useToast } from '../../../../../providers/ToastProvider';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { translate } from '../../../../../types/translation/Translator';
import { Button, ButtonVariant } from '../../../../components/Button';
import { ActionModal } from '../../../../components/Modal';
import { ProductMasterDataContext } from '../../../../../context/ProductMasterDataContext';
import { TextInput } from '../../../../components/TextInput';
import { ToastType } from '../../../../components/Toast';
import { ProductMasterData, ProductMasterDataInput } from '../../../../../types/product_master_data';
import { useMutation } from '@apollo/client';
import {
  UpdateProductMasterDataResponse,
  UpdateProductMasterDataVariables,
  ProductMasterDataMutations,
} from '../../../../../graphql/productMasterData.graphql';

interface CreateKitProductModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  input: ProductMasterDataInput;
  setInput: (input: ProductMasterDataInput) => void;
}

export default function CreateProductMasterDataLabelModal({
  open,
  setOpen,
  input,
  setInput,
}: CreateKitProductModalProps) {
  const { productMasterData, setProductMasterData } = useContext(ProductMasterDataContext);
  const { showToast } = useToast();

  const [item, setItem] = useState<string>('');

  const [update, { loading }] = useMutation<UpdateProductMasterDataResponse, UpdateProductMasterDataVariables>(
    ProductMasterDataMutations.update,
    {
      onCompleted: data => {
        const updated = data.updateProductMasterData[0];
        setProductMasterData(new Map(productMasterData).set(updated.id, new ProductMasterData(updated)));
        setInput(new ProductMasterDataInput(updated));

        showToast({
          type: ToastType.success,
          title: translate({ key: TranslationKey.labelAddedSuccessfullyToastTitle }),
        });
        setItem('');
      },
    },
  );

  const handleAdd = () => {
    if (input.labels.includes(item)) return;

    input.labels = [...input.labels, item];
    update({ variables: { productMasterData: [input.forUpdate()] } });
  };

  const footer = (
    <div className='flex justify-end gap-2'>
      <Button
        onClick={() => setOpen(false)}
        variant={ButtonVariant.secondary}
        text={translate({ key: TranslationKey.done })}
        disabled={loading}
      />
      <Button loading={loading} onClick={handleAdd} text={translate({ key: TranslationKey.add })} disabled={!item} />
    </div>
  );

  return (
    <ActionModal title={translate({ key: TranslationKey.labelCreate })} open={open} setOpen={setOpen} footer={footer}>
      <div className='grid min-w-[400px] gap-2'>
        <TextInput
          type='text'
          mandatory
          value={item}
          label={translate({ key: TranslationKey.label })}
          placeholder={translate({ key: TranslationKey.label })}
          onChange={value => {
            setItem(value);
          }}
        />
      </div>
    </ActionModal>
  );
}
